import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";

export function getSceneDataFromScenesArrBySceneId(sceneId: string, scenes: IScene[]): IScene {
    const sceneData = scenes?.find((scene: IScene) => scene.id === sceneId);
    return sceneData!;
}
